module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_6000.e93ce4ee.png";